import { render } from "./StatsWidgetTitleRender.vue?vue&type=template&id=e4a0939a"
import script from "./StatsWidgetTitleRender.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetTitleRender.vue?vue&type=script&lang=ts"

import "./StatsWidgetTitleRender.vue?vue&type=style&index=0&id=e4a0939a&lang=scss"
script.render = render

export default script